import pt_BR from './pt_BR.js';
import en from './en.js';

export const translated_messages = {
    pt_BR: pt_BR,
    en: en
}
const language = localStorage.getItem('appandweb_language') || 'pt_BR';

export default translated_messages[language];